import WebsiteBehaviors from "../website-behaviors/index.js";
import {waitUntil} from "../utils/async.js";
import {getHighlightMark, HIGHLIGHT_MARK_CLASS} from "../utils/highlight.js";

/** @var {Range|null} currentSelectionRange */
let currentSelectionRange: any = null;
/** @var {number|null} selectionInterval */
let selectionInterval: any = null;
/** @var {string} currentUrl */
let currentUrl = "";

/**
 * @param {Element} element
 * @param {string} className
 */
function isInside(element: any, className: any) {
	if (element.classList.contains(className))
		return true;

	if (element.parentElement)
		return isInside(element.parentElement, className);

	return false;
}

// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
const isValidTarget = function (element) {
	return !isInside(element, "js-aa-right-menu")
		&& !isInside(element, "js-aa-menu")
		&& !isInside(element, "js-aa-step-2");
};

class Perlego extends WebsiteBehaviors {
	identifier() {
		return "Perlego";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "ereader.perlego.com");
	}

	styles() {
		// language=CSS
		return `
			.reading-section #content .highlighted {
				background-color: unset !important;
				cursor: unset !important;
			}

			.reading-section #highlight-popup {
				display: none !important;
			}
		`;
	}

	async removePerlegoHighlights() {
		await new Promise(r => setTimeout(r, 200)); // some time for Perlego highlights to get rendered

		let element;
		// eslint-disable-next-line no-cond-assign
		while (element = document.querySelector("#content span.highlighted")) {
			const parent = element.parentNode;
			while (element.firstChild)
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
				parent.insertBefore(element.firstChild, element);
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			parent.removeChild(element);
		}
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		document.getElementById("content").normalize();
	}

	finishedLoadingPage = () => {
		return !document.querySelector("[data-test-locator=LoadingPage]");
	};

	async init() {
		await waitUntil(this.finishedLoadingPage, 300, 60000);
		await this.removePerlegoHighlights();
		await super.init();

		// Poll the location so we can re-render annotations on "page changes"
		// (tried to do this more elegantly using the "popstate" or "hashchange" events, didn't work).
		currentUrl = window.location.href;
		setInterval(async () => {
			if (currentUrl === window.location.href)
				return;

			currentUrl = window.location.href;
			await new Promise(r => setTimeout(r, 200)); // Wait until "loading" animation is present in the page
			await waitUntil(this.finishedLoadingPage, 300, 60000);
			await this.removePerlegoHighlights();
			(this as any).hooks.renderAnnotations();
		}, 500);
	}

	saveSelectionRange() {
		const selection = document.getSelection();
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		currentSelectionRange = selection.rangeCount < 1 ? null : selection.getRangeAt(0);

		if (!currentSelectionRange && selectionInterval) {
			clearInterval(selectionInterval);
			selectionInterval = null;
		}
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	mouseDown(event, bypassHighlightRules) {
		if (selectionInterval)
			clearInterval(selectionInterval);

		if (!isValidTarget(event.target))
			return;

		selectionInterval = setInterval(this.saveSelectionRange.bind(this), 100);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy) {
		if (selectionInterval) {
			clearInterval(selectionInterval);
			selectionInterval = null;
		}

		// By this point, the text selection is gone.

		// We need to wait for Perlego's highlight popup to show up on the DOM.
		try {
			await waitUntil(() => document.querySelector("#highlight-popup .highlight-popup__hover-image"), 50, 500);
			await new Promise(r => setTimeout(r, 200)); // "Click" on the "remove highlight" button to remove the Perlego annotation that was automatically generated.
			// @ts-expect-error FIXME
			(document.querySelector("#highlight-popup .highlight-popup__hover-image")).click();

			await new Promise(r => setTimeout(r, 200)); // Give it time to actually remove it
		} catch (e) {
			// Could not find Perlego's highlight popup
		}

		await this.removePerlegoHighlights(); // Just in case there's any

		// Now make the browser "select" the text (if we've captured one), so the rest of our logic can happen.
		if (currentSelectionRange !== null) {

			// Due to how the Perlego annotation system works, at this point text nodes might be "split" (e.g. a <span>
			// may have several consecutive TEXT_NODE nodes). This breaks our system, but `normalize()` merges
			// these consecutive nodes.
			currentSelectionRange.startContainer.normalize();
			currentSelectionRange.endContainer.normalize();

			const selection = document.getSelection();
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			selection.removeAllRanges();
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			selection.addRange(currentSelectionRange);

			currentSelectionRange = null;
		}

		const title = document.querySelector(".book-detail__description");
		if (title) {
			const titleParts = [title.textContent, page.getPageTitle()];
			page.setPageDataOverride({
				pageUrl:   window.location.href,
				pageTitle: titleParts.filter(t => t).join(" - ") // "[book name] - Perlego eReader"
			});
		}

		return super.mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'annotation' implicitly has an 'any' typ... Remove this comment to see the full error message
	renderHighlight(annotation, account, topicColor) {
		const uuid = super.renderHighlight(annotation, account, topicColor);
		if (!uuid)
			return uuid;

		const element = getHighlightMark(uuid);
		if (!element)
			return uuid;

		const color = (element as any).style.backgroundColor;
		this.maintainHighlightColor(uuid, color);

		return uuid;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'uuid' implicitly has an 'any' type.
	maintainHighlightColor(uuid, color) {
		const elements = document.querySelectorAll(`.${HIGHLIGHT_MARK_CLASS}[data-uuid="${uuid}"]`);
		if (!elements.length)
			return;

		/**
		 * @ts-expect-error TS(2488) FIXME: Type 'NodeListOf<Element>' must have a '[Symbol.it... Remove this comment to see the full error message
		 */
		for (const element of Array.from(elements))
			(element as any).style.backgroundColor = color;

		setTimeout(() => this.maintainHighlightColor(uuid, color), 100);
	}
}

export default Perlego;
